import { useAuth } from "@/context/AuthContext";
import { Warning, SignOut } from "@phosphor-icons/react";

// Shown only inside an impersonated (backdoor-login) tab.
export function ImpersonationBanner() {
  const { user } = useAuth();
  if (!user || !user._impersonated) return null;
  return (
    <div
      data-testid="impersonation-banner"
      className="flex items-center gap-3 px-5 py-2.5 bg-destructive text-destructive-foreground text-sm font-medium"
    >
      <Warning className="w-4 h-4 shrink-0" weight="fill" />
      <span className="truncate">
        Backdoor login — you are viewing <b>{user.name || user.contact_email || user.email}</b>
        {user._impersonator_email ? ` (opened by ${user._impersonator_email})` : ""}. Actions are attributed to your account.
      </span>
      <button
        data-testid="impersonation-exit-btn"
        onClick={() => { sessionStorage.removeItem("wa_token"); window.close(); }}
        className="ml-auto inline-flex items-center gap-1.5 rounded-md bg-black/20 hover:bg-black/30 px-2.5 py-1 transition-colors"
      >
        <SignOut className="w-4 h-4" weight="bold" /> Exit
      </button>
    </div>
  );
}
